import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import Loader from "../Loader/Loader";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import AddPickupAddressModal from "./AddPickupAddressModal";

const PickupAddress = () => {
  const pageSize = 10;
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [pickupaddressData, setPickupaddressData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [editData, setEditData] = useState({});
  const [modalAction, setModalAction] = useState("");
  const [columnData, setColumnData] = useState("");
  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);

  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setIsModalOpenCreate(false);
  };

  const pickupaddressHeader = [
    "Address Title",
    "Addressee",
    "Full Address",
    "Phone",
    "PIN Code",
    "City",
    "State",
    "Email",
  ];

  const pickupaddressHeaderToKeyMap = {
    "Address Title": "addressTitle",
    Addressee: "addressee",
    "Full Address": "fullAddress",
    Phone: "phone",
    "PIN Code": "pinCode",
    City: "city",
    State: "state",
    Email: "email",
  };

  const fetchPickupAddressData = (currentPage) => {
    const payload = {
      username: loggedInUserName,
    };

    setLoading(true);

    axiosPostApi(
      `${apiList.FETCH_PICKUPADDRESS}?&pageSize=${pageSize}&pageNo=${currentPage}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setPageDetails(response?.data?.pageDetails);
          const modifiedData = modifyStructure(response?.data?.data);
          setPickupaddressData(modifiedData);

          if (modifiedData?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setPickupaddressData([]);
          CustomAlert({
            title: "Error",
            text:
              response?.data?.message || "Failed to fetch pickup address data.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  useEffect(() => {
    fetchPickupAddressData(1);
  }, []);

  const handlePickupAddress = (data, actionType = "view") => {
    // Restrict actions to only "add", "modify", and "view"
    if (!["add", "modify", "view"].includes(actionType)) {
      return;
    }
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
    } else {
      let pickupData = pickupaddressData.find((item) => item?.id === data?.id);
      if (pickupData) {
        setEditData(pickupData);
        openModalCreate(true);
      }
    }
  };

  // Dummies for filter-related props
  const openModalFilter = () => {};
  const handleReset = () => {};
  const filterData = {};
  const fetchData = () => {};

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <MasterTable
          loading={loading}
          headers={pickupaddressHeader}
          data={pickupaddressData}
          filterFields={[]}
          entityType="Pickup Address"
          headerToKeyMap={pickupaddressHeaderToKeyMap}
          handleAction={handlePickupAddress}
          noData={noData}
          pageDetails={pageDetails}
          currentPage={currentPage}
          pageSize={pageSizeCount}
          totalRecord={totalRecord}
          fetchNextData={fetchPickupAddressData}
          setCurrentPage={setCurrentPage}
          openModalFilter={openModalFilter}
          handleReset={handleReset}
          filterData={filterData}
          fetchData={fetchData}
        />
      )}
      {isModalOpenCreate ? (
        <AddPickupAddressModal
          show={isModalOpenCreate}
          handleClose={closeModalCreate}
          editData={editData}
          action={modalAction}
          callApi={fetchPickupAddressData}
          columnData={columnData}
        />
      ) : null}
    </div>
  );
};

export default PickupAddress;
